import {
Sheet,
SheetContent,
SheetHeader,
SheetTitle,
SheetDescription,
} from '@/components/ui/sheet'
import { SaleConfigForm } from '@/features/catalog/sale-config-form'
import type { Shop } from '@/types'

interface SaleConfigSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  productId: string
  categoryId?: string
  saleConfigId: string | null
  shopId: string | null
  shops: Shop[]
  productName?: string
  onSuccess: (createdConfigId?: string) => void
}

export function SaleConfigSheet({
  open,
  onOpenChange,
  productId,
  categoryId,
  saleConfigId,
  shopId,
  shops,
  productName,
  onSuccess,
}: SaleConfigSheetProps) {
  const currentShopName = shops.find((s) => s.id === shopId)?.shopName ?? 'the current shop'

  const handleSuccess = () => {
    onSuccess()
    onOpenChange(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="sm:max-w-xl overflow-y-auto p-0">
        <SheetHeader className="p-6 pb-0">
          <SheetTitle>{saleConfigId ? 'Edit Sale Configuration' : 'Add Sale Configuration'}</SheetTitle>
          <SheetDescription>
            Define how {productName ? <strong>{productName}</strong> : 'this product'} is sold in{' '}
            <span className="font-semibold text-foreground">{currentShopName}</span>.
          </SheetDescription>
        </SheetHeader>
        <div className="px-6 mt-2">
          {productId && shopId && (
            <SaleConfigForm
              key={`${productId}:${saleConfigId ?? 'new'}`}
              productId={productId}
              categoryId={categoryId}
              saleConfigId={saleConfigId}
              shopId={shopId}
              shops={shops}
              onSuccess={handleSuccess}
              onCancel={() => onOpenChange(false)}
            />
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
}
